<div class="header">
  <spb-logo [routePath]="['/', ADMIN_MODULE]"
            title="Byggnadskreditiv"></spb-logo>
  <div [style.flex-grow]="1"></div>
  <spb-toggle-button [style.margin-right.px]="10"/>
  @if (service.currentUser()) {
    <span>{{ service.currentUser()?.name }}</span>
    <button [style.margin-right.rem]="1" [matMenuTriggerFor]="menu"
            mat-icon-button>
      <mat-icon [style.margin-top.px]="1">menu</mat-icon>
    </button>
  }
</div>

<mat-menu #menu="matMenu">
  <button (click)="service.reset()" mat-menu-item>Logga ut</button>
</mat-menu>